export const getEnvVars = () => {
    const loc = window.location;
    const secure = loc.protocol === "https:";

    // Default to the origin the app was served from.
    //
    // Whatever serves the client also proxies the backend paths: nginx in the
    // docker stack (/api, /oauth, /websocket -> server:5000), apache in the
    // .deb (same paths -> localhost:5000). So the client never needs to know
    // the server's port or hostname.
    //
    // This is what lets the docker stack publish only the client's port, and
    // what makes the app work unchanged when it's reached over the LAN by IP,
    // by hostname, or through a reverse proxy on another port entirely.
    const uri = `${loc.protocol}//${loc.host}`;
    const ws_uri = `${secure ? "wss:" : "ws:"}//${loc.host}/websocket`;

    // Overridable for development, where the CRA dev server and the backend
    // are separate origins -- see .devcontainer/devcontainer.json, which sets
    // both. Production builds should leave these unset so the defaults apply.
    const envVars = {
        serverUrl: process.env.REACT_APP_API_URL || uri,
        websocketUrl: process.env.REACT_APP_WS_URL || ws_uri
    };

    console.debug(envVars);
    return envVars;

};
